export default __webpack_public_path__ + "static/media/JO_Social_Media.0bae7b8f.png";